import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import { v4 as uuidv4 } from 'uuid';
import i18n from 'i18next';
import Cookies from 'js-cookie';
import { withClassNavigate } from './hocs/withClassNavigate';
import Spinner from './components/spinner/spinner';
import TopBar from './components/top-bar/top-bar';
import MainBar from './components/main-bar/main-bar';
import SideBar from './components/side-bar/side-bar';
import { getSelectedFolderMessageList } from './selectors/messages';
import MessageEditor from './components/message-editor/message-editor';
import MessageList from './components/message-list/message-list';
import MessageViewer from './components/message-viewer/message-viewer';
import MessageSnackbar from './components/message-snackbar/message-snackbar';
import NotFoundSnackbar from './components/messageNotFound-snackbar/messageNotFound-snackbar';
import CentinelaComponent from './apps/centinela_content';
import { readMessageFromUnloadedFolderByMessageId } from './services/message-read';
import { getCredentials } from './selectors/application';

import {
  clearUserCredentials,
  selectMessage,
  selectFolder,
  outboxEventNotified,
  editMessage,
  setError,
} from './actions/application';
import {
  clearSelected,
  setSelected,
  setSidebarOpenCalendar,
  setSidebarOpenCentinela,
  setSidebarOpenDatabase,
  setSidebarOpenLexon
} from './actions/messages';
import {
  setEmailShown,
  resetIdEmail,
  setCaseFile,
  setGUID,
  setFirmas,
  setEmailTemplates,
  setUserFolders,
  setDataBase,
  setConfigCalendar
} from './actions/lexon';
import { documentIdClear } from './actions/user';

import { getSelectedFolder } from './selectors/folders';

import { parseJwt } from './services/jwt';
import { AuthenticationException } from './services/fetch';
import { editNewMessage, clearSelectedMessage } from './services/application';
import {
  getFolders,
  findSentFolder,
  findSentFolderByName
} from './services/folder';
import { resetFolderMessagesCache } from './services/message';
import { readMessage } from './services/message-read';

import {
  addOrUpdateAccount,
  classifyEmail,
  getUserAccounts,
  getLexonUserId,
  getEmailTemplates
} from './services/accounts';
import './app.scss';

import LexonComponent from './apps/lexon_content';
import CalendarComponent from './apps/calendar_content';
import DataBaseComponent from './apps/database_content';
import { NOT_FOUND, PROVIDER } from './constants';
import { getContacts } from './calendar/api/calendar-api';
import VCF from 'vcf';
import { createContact } from './calendar/api/calendar-api';
import ACTIONS from './actions/lexon';
import { getContactString } from './calendar/api/contacts-api';
import Footer from './components/footer/footer';
import MessageNotFound from './components/message-not-found/message-not-found';
import { getVcfField, getPhone, xmlToJson} from './utils/utils';
import { sanitizeConfigCalendar } from './utils/configCalendar';

const MESSAGENOTFOUND_SNACKBAR_DURATION = 4000;

// Refresco automatico en segundo plano deshabilitado para imap. El refresco
// manual (boton "Actualizar" -> onRefresh() -> refreshPoll()) sigue intacto;
// solo se desactiva la reprogramacion del timer en refreshPoll(); la carga inicial
// de startPoll() se mantiene (PEC-8871).
const AUTO_POLL_ENABLED = false;

class AppContainer extends Component {
  constructor(props) {
    super(props);
    this.lastAuto = '';
    this.state = {
      sidebarOpen: false,
      sideBar: {
        collapsed: false
      },
      actualSidebarComponent: 0,
      isUpdatedDefaultAccount: false,
      isFrame: false,
      appConnectData: null
    };
    this.contactString = React.createRef('');
    this.draftTime = React.createRef('');
    this.emailLoaded = false;
    this.toggleSideBar = this.toggleSideBar.bind(this);
    this.onSetSidebarOpenCalendar = this.onSetSidebarOpenCalendar.bind(this);
    this.onSetSidebarOpenLexon = this.onSetSidebarOpenLexon.bind(this);
    this.onSetSidebarOpenDatabase = this.onSetSidebarOpenDatabase.bind(this);
    this.handleGetUserFromLexonConnector =
      this.handleGetUserFromLexonConnector.bind(this);
    this.handleGetUserFromCentinelaConnector =
      this.handleGetUserFromCentinelaConnector.bind(this);
    this.changeLexonBBDD = this.changeLexonBBDD.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
    this.clearSelectedMail = this.clearSelectedMail.bind(this);
    this.uploadContact = this.uploadContact.bind(this);
    this.getContactList = this.getContactList.bind(this);
    this.position = { X: 'Right', Y: 'Top' };

    this.submitMethod = () => null;
    this.setSubmitMethod = this.setSubmitMethod.bind(this);
    this.addAttachmentMethod = () => null;
    this.setAddAttachmentMethod = this.setAddAttachmentMethod.bind(this);
    this.addDraftMethod = () => null;
    this.setAddDraftMethod = this.setAddDraftMethod.bind(this);
    this.toastObj = null;
  }

  toastCusAnimation = {
    hide: { duration: '1' },
    show: { duration: '200' }
  };

  createGuid() {
    function _p8(s) {
      const p = `${Math.random().toString(16)}000000000`.substr(2, 8);
      return s ? `-${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
    }
    return _p8() + _p8(true) + _p8(true) + _p8();
  }

  async uploadContact(data) {
    const userId = this.props.lexon.userId;
    const mailAccount = this.props.all.login.formValues.user;
    const lexonToken = this.props.lexon.lexonToken;
    const guid = this.createGuid();

    if (!this.contactString.current) {
      this.contactString.current = await getContactString(userId, mailAccount, lexonToken);
    }

    let nxContact = {
      name: data.detail.contact.name,
      email: data.detail.contact.email,
      categories: data.detail.contact.entityType,
      phone: data.detail.contact.phone,
      mobilePhone: data.detail.contact.mobilePhone,
      guid: guid,
      filename: `/addressbooks/users/${mailAccount}/${this.contactString.current}/${guid}.vcf`
    };
    await createContact(nxContact, userId, mailAccount, lexonToken);

    window.dispatchEvent(
      new CustomEvent('contactUploaded', {
        detail: { contact: data.detail.contact }
      })
    );
  }

  extractContactsFromJson(json) {
    let result = {
      contacts: [],
      emails: []
    };
    if (json['d:multistatus'] && json['d:multistatus']['d:response']) {
      if (Array.isArray(json['d:multistatus']['d:response'])) {
        json['d:multistatus']['d:response'].forEach(element => {
          if (
            element['d:href'] &&
            element['d:href']['#text'] &&
            element['d:href']['#text']
          ) {
            let text = element['d:href']['#text']['@text'];
            if (text.includes('.vcf')) {
              let contactInfo =
                element['d:propstat'][0]['d:prop']['card:address-data'][
                  '#text'
                ]['@text'];

              const vcard = new VCF();
              vcard.parse(contactInfo);
              const card = vcard.data || {};

              const formattedContact = {
                name: getVcfField(card, 'fn'),
                email: getVcfField(card, 'email'),
                organization: getVcfField(card, 'org'),
                phone: getPhone(card, 'HOME'),
                mobilePhone: getPhone(card, 'CELL')
              };
              result.contacts.push(formattedContact);
              result.emails.push(formattedContact.email);
            }
          }
        });
      }
    }
    return result;
  }

  async getContactList() {
    let contactsNx;
    const userId = this.props.lexon.userId;
    const mailAccount = this.props.all.login.formValues.user;
    const lexonToken = this.props.lexon.lexonToken;
    try {
      contactsNx = await getContacts(
        userId,
        mailAccount,
        lexonToken,
        'contacts'
      );
    } catch (error) {
      const isNotFoundError = error.message.includes(NOT_FOUND);
      if (isNotFoundError) {
        contactsNx = await getContacts(
          userId,
          mailAccount,
          lexonToken,
          'contactos'
        );
      }
    }

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(contactsNx, 'application/xml');
    const json = xmlToJson(xmlDoc);

    let contactsInfo = this.extractContactsFromJson(json);
    let emails = contactsInfo.emails;

    window.dispatchEvent(
      new CustomEvent('getContactListResult', { detail: { contacts: emails } })
    );
  }

  hasProduct(product) {
    if (this.props.currentUser && this.props.currentUser.roles) {
      return this.props.currentUser.roles.indexOf(product) > -1;
    }

    return false;
  }

  onSetSidebarOpenCalendar(open) {
    const { configCalendar, userId, account } = this.props.lexon;
    const shortProvider =
      configCalendar && configCalendar.provider
        ? configCalendar.provider.substring(0, 2).toUpperCase()
        : null;
    if (shortProvider && shortProvider !== this.props.lexon.provider) {
      const token = this.props.lexon.lexonToken
        ? this.props.lexon.lexonToken
        : this.props.lexon.token;
      if (this.props.lexon.lexonToken) {
        switch (shortProvider) {
          case 'GO':
            window.open(
              `${window.URL_MF_GOOGLE}/calendar/access/${token}/?prov=${shortProvider}0&email=${configCalendar.account}`,
              '_blank'
            );
            break;
          case 'OU':
            window.open(
              `${window.URL_MF_OUTLOOK}/calendar/access/${token}/?prov=${shortProvider}0`,
              '_blank'
            );
            break;
          default:
            window.open(
              `calendar/access/${token}/?prov=${shortProvider}0&account=${btoa(
                account
              )}`
            );
            break;
        }
      } else if (this.props.lexon.user) {
        switch (shortProvider) {
          case 'GO':
            window.open(
              `${window.URL_MF_GOOGLE}/calendar/user/${shortProvider}0${userId}`,
              '_blank'
            );
            break;
          case 'OU':
            window.open(
              `${window.URL_MF_OUTLOOK}/calendar/user/${shortProvider}0${userId}`,
              '_blank'
            );
            break;
          default:
            window.open(`calendar/user/${shortProvider}0${userId}`);
            break;
        }
      } else {
        window.open('calendar', '_blank');
      }
    } else {
      const { isFrame } = this.state;
      if (!isFrame) {
        this.props.setSidebarOpenCalendar(open);
        this.props.setSidebarOpenLexon(false);
        this.props.setSidebarOpenCentinela(false);
        this.props.setSidebarOpenDatabase(false);
      }
    }
  }

  onSetSidebarOpenCentinela(open) {
    this.props.setSidebarOpenCentinela(open);
    this.props.setSidebarOpenLexon(false);
    this.props.setSidebarOpenCalendar(false);
    this.props.setSidebarOpenDatabase(false);
  }

  onSetSidebarOpenLexon(open) {
    this.props.setSidebarOpenLexon(open);
    this.props.setSidebarOpenCalendar(false);
    this.props.setSidebarOpenCentinela(false);
    this.props.setSidebarOpenDatabase(false);
  }

  onSetSidebarOpenDatabase(open) {
    this.props.setSidebarOpenDatabase(open);
    this.props.setSidebarOpenCentinela(false);
    this.props.setSidebarOpenLexon(false);
    this.props.setSidebarOpenCalendar(false);
  }

  onRefresh() {
    this.refreshPoll();
  }

  sendMessagePutUser(user) {
    const { selectedMessages, selected } = this.props.messages;
    const { currentUser, receivedFolder } = this.props;
    window.dispatchEvent(
      new CustomEvent('PutUserFromLexonConnector', {
        detail: {
          entry: user,
          idNavision: this.props.currentUser.idClienteLef,
          selectedMessages: selectedMessages,
          idCaseFile: this.props.lexon.idCaseFile,
          bbdd: this.props.lexon.bbdd,
          idCompany: this.props.lexon.idCompany,
          idEmail: this.props.lexon.idEmail,
          idFolder: this.props.lexon.idFolder,
          account: this.props.all.login.formValues.user,
          provider: 'IMAP',
          env: window.currentUser
            ? window.currentUser.env
            : currentUser && currentUser.env
            ? currentUser.env
            : window.REACT_APP_ENVIRONMENT,
          idResponsable:
            this.props.lexon.idResponsable ??
            this.props.currentUser.idResponsable ??
            null,
          lexonToken: this.props.lexon.lexonToken,
          folderName: receivedFolder.fullName,
        }
      })
    );

    if (
      !this.props.lexon.idEmail &&
      selectedMessages.length !== selected.length
    ) {
      window.dispatchEvent(
        new CustomEvent('LoadingMessage', { detail: this.props.lexon.idEmail })
      );
    }
  }

  handleGetUserFromLexonConnector() {
    const { userId } = this.props.lexon;
    if (userId) {
      this.sendMessagePutUser(userId);
    }
  }

  handleGetUserFromCentinelaConnector() {
    const { userId } = this.props.lexon;

    if (userId) {
      this.sendMessageCentinelaPutUser(userId);
    }
  }

  sendMessageCentinelaPutUser(user) {
    const { selectedMessages } = this.props.messages;

    window.dispatchEvent(
      new CustomEvent('PutUserFromCentinelaConnector', {
        detail: {
          user,
          selectedMessages: selectedMessages,
          account: this.props.all.login.formValues.user,
          provider: 'IMAP',
          env: window.currentUser ? window.currentUser.env : null
        }
      })
    );
  }

  setSubmitMethod(submitMethod) {
    this.setState({ submitMethod: submitMethod });
  }

  setAddAttachmentMethod(addAttachmentMethod) {
    this.setState({ addAttachmentMethod: addAttachmentMethod });
  }

  setAddDraftMethod(addDraftMethod) {
    this.setState({ addDraftMethod: addDraftMethod });
  }

  render() {
    const { lexon, messages } = this.props;

    const {
      sidebarLexonDocked,
      sidebarCalendarDocked,
      sidebarCentinelaDocked,
      sidebarDatabaseDocked
    } = messages;

    const { sideBar, isUpdatedDefaultAccount, isFrame } = this.state;

    if (!isUpdatedDefaultAccount) {
      return null;
    }

    return (
      <Fragment>
        {!isFrame && (
          <MainBar
            sideBarCollapsed={sideBar.collapsed}
            sideBarToggle={this.toggleSideBar}
          />
        )}
        <div className="app">
          <div className="d-flex w-100 h-100 main-body-container">
            <Spinner
              visible={this.props.application.activeRequests > 0}
              className="spinner"
              pathClassName="spinnerPath"
            />
            <SideBar
              collapsed={sideBar.collapsed}
              sideBarToggle={this.toggleSideBar}
              casefile={lexon.idCaseFile}
              bbdd={lexon.bbdd}
            />
            <div
              className={`content-wrapper
              ${sideBar.collapsed && !isFrame ? 'with-side-bar' : 'with-side-bar'} ${
                'custom-padding-top'
              }`}
            >
              <TopBar
                sideBarCollapsed={sideBar.collapsed}
                sideBarToggle={this.toggleSideBar}
                onRefreshClick={this.onRefresh}
                isFrame={isFrame}
                submitMethod={this.state.submitMethod}
                addAttachmentMethod={this.state.addAttachmentMethod}
                addDraftMethod={this.state.addDraftMethod}
                draftTime={this.draftTime.current}
                close={this.props.close}
              />
              {this.renderContent()}
            </div>
            {!isFrame && (
              <div className="productpanel">
                {window.SHOW_EXPERIMENTAL === '1' &&
                Object.keys(messages.cache).length > 0 ? (
                  <span
                    className="productsbutton"
                    isotip={i18n.t('productBar.calendar')}
                    isotip-position="bottom-end"
                    isotip-size="small"
                  >
                    <div
                      onClick={() => {
                        window.dispatchEvent(new CustomEvent('ResetList'));
                        this.onSetSidebarOpenCalendar(true);
                      }}
                    >
                      <img
                        src="/assets/icons/lexon/calendar.svg"
                        alt="calendar"
                      />
                    </div>
                  </span>
                ) : null}
                <span
                  className="productsbutton"
                  isotip={i18n.t('productBar.lexon')}
                  isotip-position="bottom-end"
                  isotip-size="small"
                >
                  {lexon.user &&
                  (this.hasProduct('LexON') ||
                    this.hasProduct('LEX-ON') ||
                    this.hasProduct('Lex-On')) ? (
                    <div
                      onClick={() => {
                        window.dispatchEvent(new CustomEvent('ResetList'));
                        this.onSetSidebarOpenLexon(true);
                      }}
                    >
                      <img src="/assets/icons/lexon/lexon.svg" alt="lexon" />
                    </div>
                  ) : (
                    <div>
                      <i
                        className={`styles.imgproductdisable lf-icon lf-icon-lexon-full`}
                      />
                    </div>
                  )}
                  <div className="btnselect"></div>
                </span>
                {this.hasProduct('Centinela') && (
                  <span
                    className="productsbutton"
                    isotip={i18n.t('productBar.centinela')}
                    isotip-position="bottom-end"
                    isotip-size="small"
                  >
                    <div
                      onClick={() => {
                        this.onSetSidebarOpenCentinela(true);
                        this.props.setIsActionClick(true);
                      }}
                    >
                      <img
                        src="/assets/icons/lexon/centinela.svg"
                        alt="lexon"
                      />
                    </div>
                  </span>
                )}
                {this.hasProduct('databaseconnector') &&
                  window.SHOW_EXPERIMENTAL === '1' && (
                    <div>
                      <span
                        className="productsbutton"
                        isotip={i18n.t('productBar.database')}
                        isotip-position="bottom-end"
                        isotip-size="small"
                      >
                        <div
                          onClick={() => this.onSetSidebarOpenDatabase(true)}
                        >
                          <i className="imgproductIcon lf-icon lf-icon-neo-full" />
                        </div>
                      </span>
                    </div>
                  )}
              </div>
            )}
            <div style={{
                  display: sidebarLexonDocked ? "block" : "none"
              }}>
                <LexonComponent
                  sidebarDocked={() => {
                    this.props.setSidebarOpenLexon(false);
                  }}
                />
            </div>
           
            {sidebarCalendarDocked && (
              <CalendarComponent
                sidebarDocked={() => {
                  this.props.setSidebarOpenCalendar(false);
                }}
                onSetSidebarOpenCalendar={this.onSetSidebarOpenCalendar}
              />
            )}
            {sidebarCentinelaDocked && (
              <CentinelaComponent
                sidebarDocked={() => {
                  this.props.setSidebarOpenCentinela(false);
                }}
              />
            )}
            {sidebarDatabaseDocked && (
              <DatabaseComponent
                sidebarDocked={() => {
                  this.props.setSidebarOpenDatabase(false);
                }}
              />
            )}
            <MessageSnackbar />
            <NotFoundSnackbar />
            <ToastComponent
              ref={toast => {
                this.toastObj = toast;
              }}
              id="toast_pos"
              position={{ X: 'Right', Y: 'Top' }}
              animation={{
                hide: { duration: '1' },
                show: { duration: '200' }
              }}
              timeOut={7000}
              showCloseButton
            />
          </div>
          {!isFrame && <Footer />}
        </div>
      </Fragment>
    );
  }

  renderContent() {
    const { 
      application, 
      lexon, 
      showPreview, 
      selectedMessages, 
      messageList, 
      isFullMessageContent,
      filteredMessages,
    } = this.props;

    if (lexon.documentsId || lexon.idCaseFile || lexon.isCompose) {
      return (
        <MessageEditor
          toastObj={this.toastObj}
          className="message-viewer"
          setSubmitMethod={this.setSubmitMethod}
          setAddAttachmentMethod={this.setAddAttachmentMethod}
          setAddDraftMethod={this.setAddDraftMethod}
          draftTime={this.draftTime}
        />
      );
    }
    if (
      application.newMessage &&
      Object.keys(application.newMessage).length > 0
    ) {
      return (
        <MessageEditor
          toastObj={this.toastObj}
          className="message-viewer"
          setSubmitMethod={this.setSubmitMethod}
          setAddAttachmentMethod={this.setAddAttachmentMethod}
          setAddDraftMethod={this.setAddDraftMethod}
          draftTime={this.draftTime}
        />
      );
    } else if (
      application.selectedMessage &&
      Object.keys(application.selectedMessage).length > 0 &&
      !showPreview &&
      isFullMessageContent
    ) {
      return <MessageViewer />;
    }

    return (
      <Fragment>
      {!showPreview ?  
        <MessageList className="message-grid" />
        :
        <div className="split-app-content">
          <MessageList className="message-grid" />
          {((selectedMessages.length >= 2 && messageList.length > 0)
          || (selectedMessages.length === 0 &&
            messageList.length > 0 && 
            Object.keys(application.selectedMessage).length === 0)) &&
            <MessageNotFound onRefreshClick={this.onRefresh} />
          }
          {((selectedMessages.length === 1 && 
            Object.keys(application.selectedMessage).length > 0 &&
            (messageList.length > 0 || filteredMessages.length > 0)) ||
            (selectedMessages.length === 0 && 
            Object.keys(application.selectedMessage).length > 0 &&
            (messageList.length > 0 || filteredMessages.length > 0))) &&
            <MessageViewer  />
          }
        </div>
      }
      </Fragment>
    );
  }

  registerConnectorApp() {}

  changeLexonBBDD(event) {
    this.props.setDataBase({
      bbdd: event.detail.bbdd,
      idCompany: event.detail.idCompany
    });
  }

  clearSelectedMail() {
    this.props.clearListMessages();
  }

  async componentDidMount() {
    document.title = 'Lefebvre Mail';
    const search = this.props.location.search;
    const appConnectEmail = new URLSearchParams(search).get('appConnectMail');
    const appConnectParse = appConnectEmail && parseJwt(appConnectEmail);
    this.setState({ appConnectData: appConnectParse });
    if (appConnectParse && window !== window.top) {
      localStorage.removeItem('KEY_USER_ID');
      localStorage.removeItem('KEY_HASH');
    }
    if (!appConnectParse) {
      if (
        (window.currentUser === null || window.currentUser === undefined) &&
        this.props.currentUser
      ) {
        window.currentUser = this.props.currentUser;
      }
      this.registerConnectorApp();
      const {
        userId,
        idCaseFile,
        bbdd,
        idEmail,
        mailContacts,
        documentsId,
        lexonToken,
        isCompose
      } = this.props.lexon;
      const {
        imapSsl,
        serverHost,
        serverPort,
        smtpHost,
        smtpPort,
        smtpSsl,
        smtpTls,
        user,
        password
      } = this.props.all.login.formValues;
      const { email } = this.props;
      if (userId !== null && email !== null) {
        const userAccounts = await getUserAccounts(userId, lexonToken);
        const resEmailTemplates = await getEmailTemplates({
          userId,
          lexonToken
        });
        let firmas = null;
        let configCalendar = null;
        const ac = userAccounts.data.accounts.filter(
          a =>
            a.email.toLowerCase() === email.toLowerCase() &&
            (a.provider.toUpperCase() === PROVIDER ||
              a.provider.toLowerCase() === 'IM')
        );
        if (ac.length >= 1) {
          firmas = ac[0].firmas;
          configCalendar = ac[0].configCalendar;
        }
        configCalendar = sanitizeConfigCalendar(
          configCalendar,
          userAccounts.data.accounts,
          email,
          PROVIDER
        );
        if (this.props.lexon.configCalendar !== configCalendar) {
          this.props.setConfigCalendar(configCalendar);
        }

        const GUID = uuidv4();
        const newAccount = {
          provider: PROVIDER,
          email: email,
          guid: GUID,
          defaultAccount: true,
          firmas,
          mails: [],
          sign: firmas?.find(x => x.isDefault)?.sign,
          folders: [],
          configAccount: {
            imap: serverHost,
            imapPort: serverPort,
            imapUser: user.toLowerCase(),
            imapPass: password,
            imapSsl: imapSsl,
            smtp: smtpHost,
            smtpPort: smtpPort,
            smtpSsl: smtpSsl,
            smtpTls: smtpTls
          },
          configCalendar: configCalendar
        };
        if (!newAccount.configAccount.imapPass) {
          delete newAccount.configAccount;
        }

        addOrUpdateAccount(userId, newAccount, this.props.lexon.lexonToken)
          .then(() => {
            this.setState({ isUpdatedDefaultAccount: true });            
            // Crear la nueva cookie para el usuario actual
            Cookies.set(`Lefebvre.DefaultAccount.${userId}`, GUID, {
              domain: 'lefebvre.es',
              expires: 365
            });
            this.props.setGUID(GUID);
            this.props.setFirmas(firmas);
            this.props.setEmailTemplates(resEmailTemplates.data);
          })
          .catch(error => {
            console.error('error =>', error);
          });
        if (
          idCaseFile !== null &&
          idCaseFile !== undefined &&
          idEmail == undefined
        ) {
          this.onSetSidebarOpenLexon(true);
          this.props.newMessage();
        } else if (mailContacts) {
          this.onSetSidebarOpenLexon(true);
        } else if (bbdd && !documentsId) {
          this.onSetSidebarOpenLexon(true);
        } else if (documentsId) {
          this.onSetSidebarOpenLexon(true);
        } else if (isCompose) {
          this.onSetSidebarOpenLexon(true);
        }
      } else {
        this.setState({ isUpdatedDefaultAccount: true });
      }

      if (idCaseFile || documentsId || isCompose) {
        this.props.newMessage([], '');
      }

      window.addEventListener(
        'GetUserFromLexonConnector',
        this.handleGetUserFromLexonConnector
      );

      window.addEventListener(
        'GetUserFromCentinelaConnector',
        this.handleGetUserFromCentinelaConnector
      );
      window.addEventListener('ChangedLexonBBDD', this.changeLexonBBDD);

      window.addEventListener('RemoveSelectedDocument', event => {
        const messages = [event.detail].map(msg => ({
          ...msg,
          messageId: msg.id
        }));
        this.props.setSelected(messages, false, event.detail.folder);

        dispatchEvent(
          new CustomEvent('Checkclick', {
            detail: {
              id: event.detail.id,
              extMessageId: event.detail.id,
              name: event.detail.id,
              subject: event.detail.subject,
              sentDateTime: event.detail.sentDateTime,
              folder: event.detail.folder,
              provider: 'GOOGLE',
              account: this.props.lexon.account,
              chkselected: false
            }
          })
        );
      });

      window.addEventListener('clearSelectedMail', this.clearSelectedMail);

      window.addEventListener('uploadContact', this.uploadContact);
      window.addEventListener('getContactList', this.getContactList);
    }
    window.addEventListener('beforeunload', this.handleComposeClose);
    this.setState({ isFrame: window !== window.top });
    //CustomEvent is tab-scoped — reset connector MFs to a clean state on every tab init,
    //but only if no compose session is already active by the time the timeout fires.
    setTimeout(() => {
      const { application, lexon } = this.props;
      const isComposing =
        lexon.documentsId ||
        lexon.idCaseFile ||
        lexon.isCompose ||
        (application.newMessage && Object.keys(application.newMessage).length > 0);
      if (!isComposing) {
        window.dispatchEvent(new CustomEvent('CloseComposer'));
      }
    }, 1500);
  }

  renderNotFoundModal() {
    this.props.setError('messageNotFound', 'No se encuentra el mensaje'); //tenia authentication
    setTimeout(
      () => this.props.setError('messageNotFound', null),
      MESSAGENOTFOUND_SNACKBAR_DURATION
    );
    this.props.resetIdEmail();
    if (
      this.props.lexon.idCaseFile !== null &&
      this.props.lexon.idCaseFile !== undefined
    ) {
      window.dispatchEvent(new CustomEvent('RemoveCaseFile'));
      this.props.setCaseFile({
        casefile: null,
        bbdd: this.props.lexon.bbdd,
        idCompany: this.props.lexon.idCompany
      });
    }
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async classifyEmail(message) {
    if (this.lastAuto === message.idMessage) {
      return;
    }

    this.lastAuto = message.idMessage;
    if (this.props.lexon.bbdd && this.props.email) {
      try {
        const userAccounts = await getUserAccounts(
          this.props.lexon.userId,
          this.props.lexon.lexonToken
        );

        if (userAccounts && userAccounts.data && userAccounts.data.configUser) {
          if (userAccounts.data.configUser.getContacts === true) {
            try {
              const userLexon = await getLexonUserId(
                this.props.lexon.userId,
                this.props.lexon.lexonToken
              );

              const emailDate = new Date();

              let folder = findSentFolder(this.props.folders);

              folder === null || folder === undefined || folder === ''
                ? (folder = findSentFolderByName(this.props.folders))
                : null;

              if (userLexon.data.idUser) {
                await classifyEmail(
                  message.idMessage,
                  message.message.subject,
                  emailDate,
                  message.message.recipients.map(rec =>
                    this.clearEmailAddress(rec.address)
                  ),
                  folder.fullName,
                  this.props.lexon.provider,
                  this.props.email,
                  this.props.lexon.bbdd,
                  this.props.lexon.idCompany,
                  userLexon.data.idUser,
                  this.props.lexon.lexonToken
                );
              }
            } catch (error) {
              console.error('Error classifying email:', error);
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  async componentDidUpdate() {
    const { idEmail, idFolder, emailShown } = this.props.lexon;

    if (
      Object.keys(this.props.folders.explodedItems).length > 0 &&
      idEmail &&
      !emailShown &&
      !this.emailLoaded
    ) {
      this.emailLoaded = true;

      let targetFolder;
      const explodedItems = Object.entries(this.props.folders.explodedItems);

      explodedItems.some(folder => {
        if (folder[1].fullName.toUpperCase() === idFolder.toUpperCase()) {
          targetFolder = folder[1];
        }
        return folder[1].fullName.toUpperCase() === idFolder.toUpperCase();
      });

      if (targetFolder) {
        this.props.selectFolder(targetFolder);
        this.sleep(500).then(async () => {
          let messages = [];

          try {
            const folderCache = this.props.messages.cache[
              this.props.application.selectedFolderId
            ];

            if (folderCache && typeof folderCache.values === 'function') {
              messages = Array.from(folderCache.values());
            }
          } catch (error) {
            console.error('Empty cache', error);
          }

          var message = messages.find(e => e.messageId === idEmail);
          if (message === null || message === undefined) {
            message = messages.find(e => e.messageId === '\t' + idEmail);
          }
          if (message === null || message === undefined) {
            message = messages.find(e => e.messageId === '\n' + idEmail);
          }
          if (message === null || message === undefined) {
            var info = idEmail.split('||-||');
            if (info && info.length > 0) {
              var subject = info[0];
              var date = info[1];
              message = messages.find(
                e => e.subject === subject && e.receivedDate === date
              );
            }
          }

          if (message === null || message === undefined) {
            const rm = await readMessageFromUnloadedFolderByMessageId(
              this.props.dispatch,
              this.props.credentials,
              null,
              targetFolder,
              { messageId: idEmail }
            );

            message = rm.completeMessage;
          }

          if (message) {
            if (
              this.props.application.newMessage &&
              Object.keys(this.props.application.newMessage).length > 0
            ) {
              this.props.close();
            }

            window.dispatchEvent(
              new CustomEvent('LoadingMessage', { detail: idEmail })
            );

            window.dispatchEvent(
              new CustomEvent('Checkclick', {
                detail: {
                  uid: message.uid,
                  id: idEmail,
                  extMessageId: idEmail,
                  subject: message.subject,
                  sentDateTime: message.receivedDate,
                  chkselected: true,
                  account: this.props.all.login.formValues.user,
                  folder: targetFolder.fullName,
                  provider: 'IMAP',
                  raw: null
                }
              })
            );

            window.dispatchEvent(new CustomEvent('LoadedMessage'));

            this.props.messageClicked(message);
            this.props.setEmailShown(true);
            this.onSetSidebarOpenLexon(true);
            this.emailLoaded = false;
          } else {
            this.onSetSidebarOpenLexon(true);
            this.renderNotFoundModal();
            this.emailLoaded = false;
          }
        });
      } else {
        this.onSetSidebarOpenLexon(true);
        this.renderNotFoundModal();
      }
    }

    if (
      this.props.lexon.userId !== '' &&
      this.props.outbox &&
      this.props.outbox.sent &&
      !this.props.outbox.eventNotified
    ) {
      this.props.outboxEventNotified();
      this.sentEmail(
        this.props.outbox.idMessage,
        this.props.outbox.message.subject,
        this.props.outbox.message.attachments || [],
        this.props.outbox.message.uid
      );

      await this.classifyEmail({ ...this.props.outbox });
    } else {
      this.startPoll();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.refreshPollTimeout);

    window.removeEventListener(
      'GetUserFromLexonConnector',
      this.handleGetUserFromLexonConnector
    );

    window.removeEventListener(
      'GetUserFromCentinelaConnector',
      this.handleGetUserFromCentinelaConnector
    );

    window.removeEventListener('ChangedLexonBBDD', this.changeLexonBBDD);
    window.removeEventListener('uploadContact', this.uploadContact);
    window.removeEventListener('getContactList', this.getContactList);
    window.removeEventListener('beforeunload', this.handleComposeClose);
  }

  handleComposeClose = event => {
    window.dispatchEvent(new CustomEvent("CloseComposer"));
    // PEC-8747: avisar antes de cerrar la pestaña si hay un mensaje a medio escribir o un envío en curso
    if (event && this.hasUnsentWork()) {
      event.preventDefault();
      event.returnValue = '';
    }
  };

  hasUnsentWork() {
    const { newMessage, outbox } = this.props.application || {};
    if (outbox && !outbox.sent && !outbox.error) {
      return true;
    }
    if (!newMessage) {
      return false;
    }
    const recipients = [...(newMessage.to || []), ...(newMessage.cc || []), ...(newMessage.bcc || [])];
    return recipients.length > 0 || (newMessage.subject || '').trim().length > 0;
  }

  sentEmail(id, subject, attachments, uid) {
    let sentFolder = findSentFolder(this.props.folders);

    sentFolder === null || sentFolder === undefined || sentFolder === ''
      ? (sentFolder = findSentFolderByName(this.props.folders))
      : null;

    const fullMessage = this.props.outbox?.message;

    window.dispatchEvent(
      new CustomEvent('SentMessage', {
        detail: {
          idEmail: id,
          subject: subject,
          uid: uid,
          date: new Date(),
          folder: sentFolder.fullName,
          lexonToken: this.props.lexon.lexonToken,
          account: this.props.all.login.formValues.user,
          provider: 'IMAP',
          attachments: attachments,
          fullMessage: fullMessage, 
          messageContent: fullMessage?.content, 
          messageRecipients: fullMessage?.recipients || [] 
        }
      })
    );
    
    window.dispatchEvent(new CustomEvent('LoadedMessage'));
  }

  startPoll() {
    // PEC-8871: la primera carga se hace siempre (con estado recuperado de IndexedDB no hay otra
    // llamada a messages); AUTO_POLL_ENABLED solo decide si refreshPoll() se reprograma después.
    if (
      this.props.application.selectedFolderId &&
      Object.keys(this.props.folders.explodedItems).length > 0 &&
      !this.pollStarted
    ) {
      this.pollStarted = true;
      this.refreshPoll();
    }
  }

  /**
   * Poll function that will refresh the folder list and the INBOX folder.
   *
   * @returns {Promise<void>}
   */
  async refreshPoll() {
    let keepPolling = true;
    let folderPromise;
    try {
      folderPromise = this.props.reloadFolders();
      const selectedFolder =
        this.props.folders.explodedItems[
          this.props.application.selectedFolderId
        ] || {};
      const messagePromise = this.props.reloadMessageCache(selectedFolder);
      const exitUnAuthorized = await folderPromise;

      if (exitUnAuthorized?.unAuthorized) {
        keepPolling = false;
        this.props.setError('authentication', 'SMTP');
      }

      await Promise.all([folderPromise, messagePromise]);
    } catch (e) {
      if (e instanceof AuthenticationException) {
        // PEC-8747: un fallo de autenticación al refrescar no cierra la sesión ni borra el almacenamiento
        keepPolling = false;
      }
    }
    if (keepPolling && AUTO_POLL_ENABLED) {
      this.refreshPollTimeout = setTimeout(
        this.refreshPoll.bind(this),
        this.props.application.pollInterval
      );
    }
  }

  toggleSideBar() {
    const toggleCollapsed = !this.state.sideBar.collapsed;
    this.setState({
      sideBar: {
        collapsed: toggleCollapsed
      }
    });
  }

  clearEmailAddress(address) {
    const regExp = /<([^>]+)?>/;
    const result = regExp.exec(address);

    if (result && result.length >= 2) {
      return result[1];
    }
    return address;
  }
}

AppContainer.propTypes = {
  application: PropTypes.object,
  outbox: PropTypes.object,
  folders: PropTypes.object,
  reloadFolders: PropTypes.func,
  reloadMessageCache: PropTypes.func,
  loadMessageByFolder: PropTypes.func,
  newMessage: PropTypes.func.isRequired,
  resetIdEmail: PropTypes.func
};

const mapStateToProps = state => ({
  application: state.application,
  outbox: state.application.outbox,
  isInvalidAuth: state.application.isInvalidAuth,
  folders: state.folders,
  receivedFolder: getSelectedFolder(state) || {},
  messages: state.messages,
  isFullMessageContent: state.messages.isFullMessageContent,
  lexon: state.lexon,
  email: state.login.formValues.user,
  all: state,
  currentUser: state.currentUser,
  credentials: getCredentials(state),
  showPreview: state.application.showPreview,
  selectedMessages: state.messages.selected,
  messageList: getSelectedFolderMessageList(state),
  filteredMessages: state.application.filteredMessages,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  reloadFolders: credentials => getFolders(dispatch, credentials, true, true),
  reloadMessageCache: (user, folder) =>
    resetFolderMessagesCache(dispatch, user, folder),
  newMessage: (to, sign) => editNewMessage(dispatch, to, sign),
  selectFolder: (folder, user) => {
    dispatch(selectFolder(folder));
    clearSelectedMessage(dispatch);
    dispatch(clearSelected());
    resetFolderMessagesCache(dispatch, user, folder);
  },
  messageClicked: (credentials, downloadedMessages, folder, message) => {
    dispatch(selectMessage(message));
    readMessage(dispatch, credentials, downloadedMessages, folder, message);
  },
  setEmailShown: flag => dispatch(setEmailShown(flag)),
  outboxEventNotified: () => dispatch(outboxEventNotified()),
  logout: () => {
    dispatch(clearUserCredentials());
    ownProps.navigate('/login');
  },
  close: props => {
    window.dispatchEvent(new CustomEvent('CloseComposer'));
    dispatch(editMessage(null));
    dispatch(ACTIONS.setInterveners(null));
    dispatch(ACTIONS.setIsCompose(false));
    dispatch(
      ACTIONS.setCaseFile({
        casefile: null,
        bbdd: props?.lexon?.bbdd,
        idCompany: props?.lexon?.idCompany
      })
    );
    dispatch(documentIdClear(null));
  },
  setError: (err, msg) => dispatch(setError(err, msg)),
  resetIdEmail: () => dispatch(resetIdEmail()),
  setCaseFile: casefile => dispatch(setCaseFile(casefile)),
  setSelected: (messages, selected, shiftKey) =>
    dispatch(setSelected(messages, selected, shiftKey)),
  setDataBase: ddbb => dispatch(setDataBase(ddbb)),
  setGUID: guid => dispatch(setGUID(guid)),
  setFirmas: firmas => dispatch(setFirmas(firmas)),
  setEmailTemplates: template => dispatch(setEmailTemplates(template)),
  setUserFolders: folders => dispatch(setUserFolders(folders)),
  setConfigCalendar: config => dispatch(setConfigCalendar(config)),
  clearListMessages: () => dispatch(clearSelected()),
  setSidebarOpenCalendar: sidebarCalendarDocked =>
    dispatch(setSidebarOpenCalendar(sidebarCalendarDocked)),
  setSidebarOpenCentinela: sidebarCentinelaDocked =>
    dispatch(setSidebarOpenCentinela(sidebarCentinelaDocked)),
  setSidebarOpenLexon: sidebarLexonDocked =>
    dispatch(setSidebarOpenLexon(sidebarLexonDocked)),
  setSidebarOpenDatabase: sidebarDatabaseDocked =>
    dispatch(setSidebarOpenDatabase(sidebarDatabaseDocked)),
  setUser: user => dispatch(ACTIONS.setUser(user)),
  setAccount: account => dispatch(ACTIONS.setAccount(account)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps, {
    reloadFolders: () =>
      dispatchProps.reloadFolders(stateProps.application.user.credentials),
    reloadMessageCache: folder =>
      dispatchProps.reloadMessageCache(stateProps.application.user, folder),
    selectFolder: folder =>
      dispatchProps.selectFolder(folder, stateProps.application.user),
    messageClicked: message =>
      dispatchProps.messageClicked(
        stateProps.application.user.credentials,
        stateProps.application.downloadedMessages,
        stateProps.receivedFolder,
        message
      ),
    setEmailShown: flag => dispatchProps.setEmailShown(flag),
    outboxEventNotified: () => dispatchProps.outboxEventNotified(),
    close: () => dispatchProps.close(stateProps),
    setError: (err, msg) => dispatchProps.setError(err, msg),
    resetIdEmail: () => dispatchProps.resetIdEmail(),
    setCaseFile: casefile => dispatchProps.setCaseFile(casefile)
  });

const ConnectedAppContainer = withClassNavigate(connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AppContainer));

export default ConnectedAppContainer;
